document.addEventListener('DOMContentLoaded', function() {
  var loadMoreButton = document.getElementById('load-more');
  var loadMoreContainer = document.getElementById('load-more-container');
  var productGrid = document.getElementById('product-grid');
  var isLoading = false;
  var page = 2;

  function loadMoreProducts() {
    if (isLoading) {
      return;
    }

    isLoading = true;
    var url = loadMoreButton.getAttribute('data-url') + '&view=products-grid';

    fetch(url)
      .then(function(response) {
        return response.text();
      })
      .then(function(html) {
        var tempContainer = document.createElement('div');
        tempContainer.innerHTML = html;
        var newProducts = tempContainer.querySelectorAll('#product-grid li');
        var newLoadMoreButton = tempContainer.querySelector('#load-more');

        if (newProducts.length > 0) {
          Array.from(newProducts).forEach(function(product) {
            productGrid.appendChild(product);
          });
          page++;
          isLoading = false;
        }

        if (newLoadMoreButton) {
          loadMoreButton.setAttribute('data-url', newLoadMoreButton.getAttribute('data-url'));
        } else {
          loadMoreContainer.style.display = 'none';
        }
      })
      .catch(function(error) {
        console.error('Error loading more products:', error);
        isLoading = false;
      });
  }

  function handleScroll() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var gridBottom = productGrid.offsetTop + productGrid.offsetHeight;

    if (scrollTop + windowHeight >= gridBottom) {
      loadMoreProducts();
    }
  }

  if (loadMoreButton) {
    window.addEventListener('scroll', handleScroll);
    handleScroll();
  }
});
